import $ from "jquery";

const dienstenCard = () => {
  const $cards = $(".diensten-card");
  if (!$cards.length) return;

  $cards.on("mouseenter", function () {
    $cards.not(this).addClass("minimized");
    $(this).removeClass("minimized");
  });

  $cards.on("mouseleave", function () {
    $cards.removeClass("minimized");
  });
};

try {
  dienstenCard();
} catch (error) {
  console.error(error);
}
